export const getSavedIndividualsStorageKey = (email = "") =>
  `routeplanner:saved-individuals:${String(email || "")
    .trim()
    .toLowerCase()}`;

export const createEmptyIndividual = () => ({
  savedInfoId: null,
  name: "",
  type: "",
  project: "",
  vertical: "",
  gender: "",
  dob: "",
  age: "",
  idType: "",
  idNumber: "",
  idProof: null,
  idProofUrl: "",
  existingIdProof: null,
  contactNumber: "",
  idProofDeclarationAccepted: false,
});

export const isIndividualBlank = (individual = {}) =>
  ![
    individual.savedInfoId,
    individual.name,
    individual.type,
    individual.project,
    individual.vertical,
    individual.gender,
    individual.dob,
    individual.idType,
    individual.idNumber,
    individual.idProof,
    individual.idProofUrl,
    individual.existingIdProof,
    individual.contactNumber,
  ].some(Boolean);

export const calculateAgeLabel = (dobValue) => {
  if (!dobValue) return "";

  const dob = new Date(dobValue);

  if (Number.isNaN(dob.getTime())) return "";

  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();

  const monthDiff = today.getMonth() - dob.getMonth();

  const dayDiff = today.getDate() - dob.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age -= 1;
  }

  return age >= 0 ? `${age} Years ` : "";
};

export const getDobInputValue = (dobValue) => {
  if (!dobValue) return "";
  return String(dobValue).split("T")[0];
};

export const buildIndividualFromSaved = (savedIndividual = {}) => ({
  ...createEmptyIndividual(),
  savedInfoId: savedIndividual.id || null,
  name: savedIndividual.name || "",
  type: savedIndividual.type || "",
  project: savedIndividual.project || "",
  vertical: savedIndividual.vertical || "",
  gender: savedIndividual.gender || "",
  dob: getDobInputValue(savedIndividual.dob),
  age:
    savedIndividual.ageDisplay ||
    calculateAgeLabel(savedIndividual.dob),
  idType: savedIndividual.idType || "",
  idNumber: savedIndividual.idNumber || "",
  idProofUrl: savedIndividual.idProof || "",
  existingIdProof: savedIndividual.idProof || null,
  contactNumber: savedIndividual.contactNumber || "",
  idProofDeclarationAccepted: false,
});

export const isTravelSupport = (supportNeeded) =>
  ["Travel", "Travel + Accommodation"].includes(supportNeeded);

export const isTrainPreference = (travelPreference) =>
  travelPreference === "Train";

export const isBusPreference = (travelPreference) =>
  travelPreference === "Bus";

export const getTodayInputDate = () => {
  const now = new Date();

  const year = now.getFullYear();

  const month = String(now.getMonth() + 1).padStart(2, "0");

  const day = String(now.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getCleanFileName = (url) => {
  if (!url) return "";

  const cleanUrl = decodeURIComponent(url.split("?")[0]);

  const fullName = cleanUrl.substring(
    cleanUrl.lastIndexOf("/") + 1
  );

  const parts = fullName.split("-");

  if (parts.length > 4) {
    return parts.slice(4).join("-");
  }

  return fullName.replace(/^\d+-/, "");
};

export const parseStoredFileValue = (fileValue) => {
  if (!fileValue || typeof fileValue !== "string") {
    return {
      raw: "",
      url: "",
      name: "",
    };
  }

  if (fileValue.includes("$")) {
    const [name, url] = fileValue.split("$");

    return {
      raw: fileValue,
      url: url || "",
      name: name || getCleanFileName(url || ""),
    };
  }

  return {
    raw: fileValue,
    url: fileValue,
    name: getCleanFileName(fileValue),
  };
};

export const getFinalDeclarationText = (isReimbursement) =>
  isReimbursement
    ? "I hereby declare that all reimbursement details, payment information, uploaded bills, travel documents, and supporting proofs submitted in this request are true and accurate to the best of my knowledge. I confirm that the claimed expenses were incurred for official/business purposes only. I understand that submitting incorrect information or fake documents may lead to request rejection or disciplinary action."
    : "I hereby declare that all information provided in this request, including travel details, uploaded documents, and individual details are true and accurate to the best of my knowledge. I understand that providing false information may result in request rejection or disciplinary action.";

export const getTravelClassOptions = (preference) => {
  switch (preference) {
    case "Bus":
      return ["General", "Sleeper", "AC", "Non-AC"];

    case "Train":
      return ["General", "Sleeper", "3AC", "2AC", "1AC"];

    case "Flight":
      return ["Economy", "Business", "First Class"];

    default:
      return [];
  }
};